import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { protectedResources } from 'src/app/auth/auth.config';
import { CompanyType, MemberType } from '../models/company.model';
import {
  CompanyRoleType,
  CompanyRoleValue,
  UserRole,
} from '../models/user.model';

@Injectable({
  providedIn: 'root',
})
export class CompanyService {
  constructor(private http: HttpClient) {}
  apiEndpoint: string = protectedResources.apiTodoList.endpoint;

  getCompany(companyId: string) {
    return this.http.get<CompanyType>(
      `${this.apiEndpoint}/companies/${companyId}`,
    );
  }

  getCompanyMembers(companyId: string): Observable<MemberType[]> {
    return this.http
      .get<
        CompanyRoleType[]
      >(`${this.apiEndpoint}/companies/${companyId}/members`)
      .pipe(
        map((members) =>
          members.map((member) => ({
            userId: member.userId,
            email: member.email,
            firstName: member.firstName,
            lastName: member.lastName,
            role: this.roleMapping(member.role),
            ...(member.licenseBatches !== undefined
              ? { licenseBatches: member.licenseBatches }
              : {}),
          })),
        ),
      );
  }

  editCompany(data: CompanyType) {
    return this.http.put<CompanyType>(
      `${this.apiEndpoint}/companies/${data.id}`,
      data,
    );
  }

  createCompany(data: CompanyType) {
    return this.http.post<CompanyType>(`${this.apiEndpoint}/companies`, data);
  }

  getInviteLinkAsBase64(companyId: string) {
    return this.http
      .get(`${this.apiEndpoint}/companies/${companyId}/invite`, {
        responseType: 'text',
      })
      .pipe(map((inviteLink) => btoa(inviteLink)));
  }

  sendInviteViaEmail(companyId: string, email: string) {
    return this.http.post(`${this.apiEndpoint}/companies/${companyId}/invite`, {
      email: email,
      redirectUri: window.location.host + '/join',
    });
  }

  deleteMember(memberId: string, companyId: string) {
    return this.http.delete(
      `${this.apiEndpoint}/companies/${companyId}/members/${memberId}`,
    );
  }

  deleteCompany(companyId: string) {
    return this.http.delete(`${this.apiEndpoint}/companies/${companyId}`);
  }

  static isCompanyComplete(data: CompanyType): boolean {
    return Boolean(
      data.country && data.name && data.industry && data.stateOrProvince,
    );
  }

  userRoleToCompanyRole = (role: UserRole): CompanyRoleValue => {
    switch (role) {
      case UserRole.ADMIN:
        return '1';
      case UserRole.MAINTAINER:
        return '2';
      default:
        return '0';
    }
  };

  roleMapping = (role: CompanyRoleValue | undefined | null) => {
    const roleNumber =
      typeof role === 'string' ? Number.parseInt(role, 10) : role;

    switch (roleNumber) {
      case 0:
        return UserRole.PILOT;
      case 1:
        return UserRole.ADMIN;
      case 2:
        return UserRole.MAINTAINER;
      default:
        return UserRole.PILOT;
    }
  };
}
